export default __webpack_public_path__ + "static/illustration-content-btn.url-7509124bb8c626581f80885ae304db75.svg";